import { useEffect, useState } from "react";

import { Loader2 } from "lucide-react";

export interface LoadingSpinnerProps {
  delay?: number;
  reason?: string;
}
export function LoadingSpinner({
  delay = 2000,
  reason,
}: Readonly<LoadingSpinnerProps>) {
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!showSpinner) {
    return null;
  }

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex h-full items-center justify-center">
      <Loader2
        className="h-8 w-8 animate-spin cursor-pointer text-gray-900"
        onClick={handleReload}
        data-reason={reason}
      />
    </div>
  );
}
